import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRecKeyframe2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rec-keyframe-2, rhombus"><path d="M12 2.25L2.25 12L12 21.75L21.75 12L12 2.25Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="2.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRecKeyframe2;
